<app-progress-spinner class="dialog-loader__circular-progress" />
